module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FBkzzh/tc-custom/9781459235113.jpg?1741131129461",
      "alt": "This image is the cover for the book His Unsuitable Viscountess"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("His Unsuitable Viscountess\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A lifetime of living in a man's world has given sword-making-factory owner Eleanor Blackwell some very definite opinionsparticularly about the duplicity  of men!"), _c('br'), _c('br'), _vm._v("Benjamin Grayson, Viscount Whittonstall, seems  to be cut from a different clothEleanor responds to his touch with a passion normally reserved only for fencing! She may be spectacularly unsuited to mix with aristocracy, but Ben has different ideas when he plans  to safeguard her business with a very  convenient proposal."), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michelle Styles\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Michelle Styles writes warm, witty and intimate historical romance in a range of periods including Viking  and early Victorian. Born and raised near San Francisco, California,  she  currently lives near Hadrian's Wall in the UK with her husband, menagerie of pets and occasionally one of her three university-aged children. An avid reader, she became hooked on historical romance after discovering  Georgette Heyer, Anya Seton and Victoria Holt.   ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0